<template>
  <div>
    <div ref="card" class='stripe-card' :class='{ complete }' :disabled="submiting"></div>
    <div v-if="error">{{error.message}}</div>
    <button @click.prevent="submit" :disabled="!complete || submiting">
      <span v-if="submiting">spinner...</span>
      <span v-else>Save</span>
    </button>
    <router-link to="/payments" :disabled="submiting">close</router-link>
  </div>
</template>

<script>
import firebase from '../../../firebase-app'
import stripe from '../../../stripe'
import { mapState } from 'vuex'

const style = {
  base: {
    fontSize: '16px',
    color: '#32325d',
    fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: 'rgba(0,0,0,0.4)'
    }
  }
}

export default {
  name: 'PaymentNew',
  props: {
    planId: { type: String, required: true }
  },

  beforeMount () {
    this._card = stripe.elements().create('card', { style })
    this._card.on('change', ({ complete }) => {
      this.error = null
      this.complete = complete
    })
  },
  mounted () {
    this._card.mount(this.$refs.card)
  },
  beforeDestroy () {
    this._card.unmount()
    this._card.destroy()
  },

  computed: {
    ...mapState(['user']),

    accountId () {
      if (!this.userAccount) {
        return null
      }
      return this.userAccount['.key']
    }
  },
  data () {
    return {
      complete: false,
      submiting: false,
      error: null
    }
  },

  methods: {
    async submit () {
      this.submiting = true
      this.error = null
      try {
        const { paymentMethod: { id: paymentMethodId } } = await stripe.createPaymentMethod({
          type: 'card',
          card: this._card,
          billing_details: {
            name: this.user.displayName,
            email: this.user.email
          }
        })
        const setupFn = firebase.functions().httpsCallable('stripe-setup')
        const { data: { id, status, secret } } = await setupFn({
          paymentMethodId,
          planId: this.planId
        })
        if (status === 'requires_action') {
          await stripe.confirmCardPayment(secret)
          const subscriptionFn = firebase.functions().httpsCallable('stripe-subscription')
          await subscriptionFn({ id })
        }
        this.$emit('close')
      } catch (e) {
        console.error(e)
        this.error = e
      } finally {
        this.submiting = false
      }
    }
  }
}
</script>

<style scoped>
  .stripe-card {
    width: 300px;
    border: 1px solid grey;
  }

  .stripe-card.complete {
    border-color: green;
  }
</style>
